import { render, staticRenderFns } from "./HospitalPcare.vue?vue&type=template&id=6ca0711c&scoped=true"
import script from "./HospitalPcare.vue?vue&type=script&lang=js"
export * from "./HospitalPcare.vue?vue&type=script&lang=js"
import style0 from "./HospitalPcare.vue?vue&type=style&index=0&id=6ca0711c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca0711c",
  null
  
)

export default component.exports